<template>
  <section>
    <div class="content scrollable">
      <div class="header">
        <h2 class="title">{{ i18n.t('newsletter:title') }}</h2>
        <p class="description">{{ i18n.t('newsletter:description') }}</p>
      </div>
    </div>
    <action-bar class="nl-actions">
      <ul class="buttons columns">
        <li id="newsletter_no" @click="selectAnswer(false)">
          <span>{{ i18n.t('newsletter:no') }}</span>
        </li>
        <li id="newsletter_yes" @click="selectAnswer(true)" class="primary">
          <span>{{ i18n.t('newsletter:yes') }}</span>
        </li>
      </ul>
    </action-bar>
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/mixins";

section {
  margin-top: 15% !important;

  @include desktop {
    margin-top: 0;
  }

  & .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 40px 30px 30px;
    margin: -30px;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    @include desktop {
      padding: 20px 30px 30px;
    }
  }
}
.overlay {
  background-color: rgba(0, 0, 0, .7);
  margin: -30px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  & .infoBox {
    background-color: #FFFFFF;
    font-weight: 300;
    margin: auto 30px;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    font-family: $newsletterDescriptionFont;
    font-size: 16px;
    line-height: 20px;
    .button {
      font-weight: bold;
      text-align: center;
      display: inline-block;
      padding: 15px 15px 0px;
      color: $newsletterButtonPrimaryBackgroundColor;
      cursor: pointer;
    }
  }
}
.modal-container {
  top: 0 !important;
  .content {
    padding: 30px;
  }
}
.title {
  font-family: $newsletterTitleFont;
  font-size: 25px;
  color: #1A212C;
  font-weight: bold;
  line-height: 32px;
  text-align: left;
  margin-right: -5px;
  margin-bottom: 25px;

  @include desktop {
    font-size: 25px;
    max-width: 360px;
  }
}
.description {
  font-family: $newsletterDescriptionFont;
  font-size: 14px;
  color: #798291;
  font-weight: 300;
  line-height: 19px;
  text-align: left;
  margin-right: 15px;
  margin-bottom: 25px;

  @include desktop {
    line-height: 23px;
  }
}
.buttons {
  @include button-list;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.columns{
    flex-direction: row;
  }

  @media (max-width: #{$small-phone-width}) {
    padding: 0;
    margin: 0;
  }

  li{
    flex-shrink: 0;
    line-height: 25px;
    padding: 17.5px 5px;
    margin: 5px 0;
    color: #000000;
    font-size: 16px;
    width: 100%;
    background-color: $newsletterButtonBackgroundColor;
    border-radius: 30px;
    box-shadow: none;
    @include tablet {
      width: $tablet-content-width;
      padding: 17.5px 5px;
    }
    & span {
      font-weight: bold;
      font-family: $mainFontFamily;
      font-size: 18px;
    }
    &.primary {
      color: #FFFFFF;
    }

    &.saving {
      color: #FFFFFF;
    }
  }
}
.items {
  list-style-type: none;
  margin: 20px -30px 50px;
  .item {
    padding: 15px 30px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: initial
  }
  .value {
    color: $newsletterDescriptionColor;
    text-align: left;
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    padding-left: 15px;
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: normal;
    & a {
      color: $newsletterDescriptionColor;
      text-decoration: underline;
    }
  }
}
.toggle-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  &.locked {
    cursor: initial;
    .toggle-button-inner {
      &:after {
        content: "";
        position: absolute;
        top: 7px;
        left: 5px;
        width: 10px;
        height: 10px;
        background-image: url('~static/lock.png');
        background-size: 10px 10px;
      }
    }
  }

  .toggle-button-inner {
    display: flex;
    width: 40px;
    height: 25px;
    background: #B6BABF;
    border-radius: 18px;
    position: relative;
    transition: background .2s ease-in;

    .checkbox {
      -webkit-appearance: checkbox;
      display: none;
    }

    .handle {
      height: 16px;
      width: 16px;
      background: #fff;
      border-radius: 50px;
      box-shadow: 0 2px 2px 0 rgba(0,0,0,0.01);
      position: absolute;
      left: 5px;
      top: 5px;
      transition: left .2s ease-in;
    }
  }

  .text {
    font-family: Arial;
    font-size: 14px;
    line-height: 22px;
    margin-left: 12px;
  }

  &.checked {

    .toggle-button-inner {
      background: $newsletterButtonPrimaryBackgroundColor;
      .handle {
        left: calc(100% - 21px);
      }
    }
  }
}
</style>

<script>
import Vue from 'vue'
import ToggleButton from '../components/ToggleButton'

export default Vue.component('GDPR-screen', {
  components: {
    'toggle-button': ToggleButton
  },
  props: ['screenParams'],
  data () {
    return {
      isSaving: false
    }
  },
  methods: {
    selectAnswer (answer) {
      this.$store.dispatch('updateConsent', {
        newsletter: {
          consent: answer
        }
      })
      this.$store.dispatch('next', {...this.screenParams.nextScreenRoute, skipDelay: true})
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/screens/Newsletter.vue